import type {ContentAdapter} from '../adapters/content-adapter.ts';
import type {Store} from '../lib/store.ts';
import type {ReaderListing} from '../pages/reader/reader-listing.ts';
import type {Article, RelatedArticle} from './article.ts';
import {ReaderEdition} from './reader-edition.ts';

export class SingleArticleEdition extends ReaderEdition {
	readonly #article: Article;
	readonly sourceId: string;

	constructor(article: Article, adapter: ContentAdapter) {
		if (!article.sourceId) {
			throw new Error('Article for SingleArticleEdition must have a sourceId.');
		}

		const uniqueId = `${article.sourceId}:${article.id}`;
		super(adapter);

		this.id = uniqueId;
		this.title = article.title;
		this.productTitle = article.title;
		this.publishDate = new Date(article.publishedAt).toISOString();
		this.productName = article.sourceId;
		this.productId = '';
		this.productType = 'article';
		this.editionType = 'article';
		this.label = article.title;
		this.#article = article;
		this.articles = [article];
		this.sourceId = article.sourceId;
	}

	async loadArticleList(_store: Store) {
		return this.articles;
	}

	getPath(): string {
		return `/article/${this.sourceId}/${this.#article.id}`;
	}

	getArticleUrl(_article: ReaderListing, pageNumber: number): string {
		if (pageNumber && pageNumber > 1) {
			return `${this.getPath()}/${pageNumber}`;
		}

		return this.getPath();
	}

	async loadFullArticle(
		article: Article,
		_groupBy: string,
		_sortOrder: number | undefined,
		_store: Store
	): Promise<Article | null> {
		return article;
	}

	getSection(listing: ReaderListing): string {
		return listing.item.section;
	}

	async loadRelatedArticles(article: Article): Promise<RelatedArticle[]> {
		return this.adapter.loadRelatedArticles(article, this.sourceId);
	}
}
